import { render, staticRenderFns } from "./DashboardAnnonate.vue?vue&type=template&id=1b8f2f60&scoped=true&"
import script from "./DashboardAnnonate.vue?vue&type=script&lang=ts&"
export * from "./DashboardAnnonate.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAnnonate.vue?vue&type=style&index=0&id=1b8f2f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f2f60",
  null
  
)

export default component.exports